<template>
  <div class="ap-sub-panel">
    <div class="ap-query-row">
      <el-form :model="nmQuery" label-position="right" label-width="190px" class="ap-query" @keyup.enter.native="searchNm">
        <el-row>
          <el-col :xl="8" :lg="8" :md="12">
            <el-form-item label="Network Maintenance Mode">
              <el-select clearable size="small" v-model="nmQuery.maintenanceMode" placeholder="Please select" style="width:100%">
                <el-option v-for="m in maintenanceModeOptions" :key="m.value" :label="m.label" :value="m.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12">
            <el-form-item label="Third-party Vendor Name">
              <el-input clearable size="small" v-model="nmQuery.thirdPartyVendorName" placeholder="Please input"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12">
            <el-form-item label="Third-party Service Cost">
              <el-input clearable size="small" v-model="nmQuery.thirdPartyServiceCost" placeholder="Please input"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12">
            <el-form-item label="Customer Satisfaction">
              <el-input clearable size="small" v-model="nmQuery.thirdPartyCustomerSatisfaction" placeholder="Please input"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="16" :lg="16" :md="24" class="ap-btn-col">
            <el-button type="primary" size="small" @click="searchNm">Search</el-button>
            <el-button size="small" @click="resetNm">Reset</el-button>
            <el-button size="small" :loading="nmExportLoading" @click="exportNm">Export</el-button>
            <el-button v-if="hasOperationPermission" type="primary" size="small" @click="addNm">+ Add</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table :data="nmTableData" size="small" border style="width:100%" :header-cell-style="{background:'#F5F5F9'}" @sort-change="nmSortChange" v-loading="nmLoading">
      <el-table-column label="No" width="70" align="center">
        <template slot-scope="scope">{{ (nmPage - 1) * nmPageSize + scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="selfMaintenance" label="Self-maintenance" width="165" sortable="custom" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.selfMaintenance !== null && scope.row.selfMaintenance !== undefined && scope.row.selfMaintenance !== ''" :class="['ap-tag', 'ap-tag-' + warrantyTagClass(scope.row.selfMaintenance)]">{{ scope.row.selfMaintenance === true ? 'Yes' : 'No' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Third-party Maintenance" align="center">
        <el-table-column prop="thirdPartyVendorName" label="Third-party Vendor Name" min-width="215" sortable="custom" align="left" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="thirdPartyServiceCost" label="Third-party Service Cost" min-width="210" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="thirdPartyCustomerSatisfaction" label="Customer Satisfaction" min-width="190" sortable="custom" align="center"></el-table-column>
      </el-table-column>
      <el-table-column prop="updatedBy" label="Modifier" width="120" sortable="custom" align="center"></el-table-column>
      <el-table-column prop="updatedTime" label="Modified Time" width="150" sortable="custom" align="center"></el-table-column>
      <el-table-column v-if="hasOperationPermission" label="Operation" width="170" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="modifyNm(scope.row)">Modify</el-button>
          <el-button type="danger" size="mini" @click="deleteNm(scope.row)" style="margin-left:5px">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="ap-pagination">
      <span class="ap-pagination-total">Total {{ nmTotal }}</span>
      <el-pagination small layout="prev, pager, next, sizes" :total="nmTotal" :current-page.sync="nmPage" :page-sizes="[10,20,50]" :page-size.sync="nmPageSize" @current-change="v => { nmPage = v; loadNmData() }" @size-change="v => { nmPageSize = v; nmPage = 1; loadNmData() }"></el-pagination>
    </div>

    <!-- NM Add/Modify Modal -->
    <el-dialog :title="nmDialogTitle" :visible.sync="nmDialogVisible" width="560px" custom-class="nm-dialog">
      <el-form :model="nmForm" ref="nmForm" label-position="top" :rules="nmRules">
        <el-form-item label="Network Maintenance Mode" prop="maintenanceMode">
          <el-radio-group v-model="nmForm.maintenanceMode" @change="onNmModeChange">
            <el-radio v-for="m in maintenanceModeOptions" :key="m.value" :label="m.value">{{ m.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="nmForm.maintenanceMode === 'Third-party Maintenance'">
          <el-form-item label="Third-party Vendor Name">
            <el-input size="small" v-model="nmForm.thirdPartyVendorName" placeholder="Please input" clearable></el-input>
          </el-form-item>
          <el-form-item label="Third-party Service Cost">
            <el-input size="small" v-model="nmForm.thirdPartyServiceCost" placeholder="Please input" clearable></el-input>
          </el-form-item>
          <el-form-item label="Customer Satisfaction">
            <el-input size="small" v-model="nmForm.thirdPartyCustomerSatisfaction" placeholder="Please input" clearable></el-input>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="nmDialogVisible = false">Cancel</el-button>
        <el-button type="primary" size="small" :loading="nmSaving" @click="saveNm" style="margin-left: 6px">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AccountProfileNetworkMaint',
  props: {
    accountInfo: { type: Object, default: () => ({}) },
    hasOperationPermission: { type: Boolean, default: false }
  },
  data() {
    return {
      satisfactionOptions: [],
      maintenanceModeOptions: [],
      nmQuery: { maintenanceMode: '', thirdPartyVendorName: '', thirdPartyServiceCost: '', thirdPartyCustomerSatisfaction: '' },
      nmTableData: [],
      nmLoading: false,
      nmTotal: 0,
      nmPage: 1,
      nmPageSize: 10,
      nmSortField: '',
      nmSortOrder: '',
      nmExportLoading: false,
      nmDialogVisible: false,
      nmDialogTitle: 'Add',
      nmEditId: null,
      nmSaving: false,
      nmForm: { maintenanceMode: 'Self-maintenance', thirdPartyVendorName: '', thirdPartyServiceCost: '', thirdPartyCustomerSatisfaction: '' },
      nmRules: { maintenanceMode: [{ required: true, message: 'Please select Network Maintenance Mode', trigger: 'change' }] },
    }
  },
  created() {
    this.initDropdownData()
    this.loadNmData()
  },
  watch: {
    'accountInfo.id'(newVal) {
      if (newVal) this.loadNmData()
    }
  },
  methods: {
    warrantyTagClass(v) { return v === true ? 'green' : (v === false ? 'red' : '') },
    loadData() {
      this.loadNmData()
    },
    initDropdownData() {
      let kvUrl = `${this.$store.state.islhurl}keyValue/queryLabelList?`
      const kvKeys = ['MaintenanceMode', 'Satisfaction']
      kvKeys.forEach((k, i) => { kvUrl += (i === 0 ? '' : '&') + `keyList=${k}` })
      this._get(kvUrl).then(res => {
        if (res.code === 200 && res.data) {
          this.maintenanceModeOptions = res.data.MaintenanceMode || []
          this.satisfactionOptions = res.data.Satisfaction || []
        }
      }).catch(() => {})
    },
    satisfactionTagClass(v) { return { 'Very Satisfied': 'green', 'Satisfied': 'green', 'Neutral': 'orange', 'Dissatisfied': 'red' }[v] || 'gray' },
    _sortFieldMap(prop) {
      const map = { maintenanceMode: 'maintenanceMode', thirdPartyVendorName: 'thirdPartyVendorName', thirdPartyServiceCost: 'thirdPartyServiceCost', thirdPartyCustomerSatisfaction: 'thirdPartyCustomerSatisfaction', updatedBy: 'updatedBy', updatedTime: 'updatedTime' }
      return map[prop] || prop
    },
    loadNmData() {
      const id = this.accountInfo.id
      if (!id) return
      let params = {
        pageNum: this.nmPage,
        pageSize: this.nmPageSize,
        maintenanceMode: this.nmQuery.maintenanceMode || undefined,
        thirdPartyVendorName: this.nmQuery.thirdPartyVendorName || undefined,
        thirdPartyServiceCost: this.nmQuery.thirdPartyServiceCost || undefined,
        thirdPartyCustomerSatisfaction: this.nmQuery.thirdPartyCustomerSatisfaction || undefined,
        sortField: this.nmSortField ? this._sortFieldMap(this.nmSortField) : undefined,
        sortOrder: this.nmSortOrder === 'ascending' ? 'asc' : (this.nmSortOrder === 'descending' ? 'desc' : undefined),
      }
      Object.keys(params).forEach(key => { if (params[key] === undefined || params[key] === '') delete params[key] })

      this.nmLoading = true
      let url = `${this.$store.state.islhurl}valued-account/profile/${id}/network-maintenance`
      this.$axios.get(url, { params }).then(res => {
        this.nmLoading = false
        const data = res.data
        if (data.code === 200) {
          this.nmTableData = data.data || []
          this.nmTotal = data.totalSize || 0
        } else {
          this.nmTableData = []
          this.nmTotal = 0
          this.$message.error(data.msg || 'Failed!')
        }
      }).catch(() => {
        this.nmLoading = false
        this.nmTableData = []
        this.nmTotal = 0
      })
    },
    searchNm() { this.nmPage = 1; this.loadNmData() },
    resetNm() { this.nmQuery = { maintenanceMode: '', thirdPartyVendorName: '', thirdPartyServiceCost: '', thirdPartyCustomerSatisfaction: '' }; this.nmSortField = ''; this.nmSortOrder = ''; this.nmPage = 1; this.loadNmData() },
    nmSortChange({ prop, order }) { this.nmSortField = order ? (prop || '') : ''; this.nmSortOrder = order || ''; this.nmPage = 1; this.loadNmData() },
    onNmModeChange() { if (this.nmForm.maintenanceMode === 'Self-maintenance') { this.nmForm.thirdPartyVendorName = ''; this.nmForm.thirdPartyServiceCost = ''; this.nmForm.thirdPartyCustomerSatisfaction = '' } },
    addNm() { this.nmEditId = null; this.nmDialogTitle = 'Add Network Maintenance Mode'; this.nmForm = { maintenanceMode: '', thirdPartyVendorName: '', thirdPartyServiceCost: '', thirdPartyCustomerSatisfaction: '' }; this.nmDialogVisible = true; this.$nextTick(() => this.$refs.nmForm && this.$refs.nmForm.clearValidate()) },
    modifyNm(row) {
      this.nmEditId = row.id
      this.nmDialogTitle = 'Modify Network Maintenance Mode'
      this.nmForm = { maintenanceMode: row.maintenanceMode, thirdPartyVendorName: row.thirdPartyVendorName || '', thirdPartyServiceCost: row.thirdPartyServiceCost || '', thirdPartyCustomerSatisfaction: row.thirdPartyCustomerSatisfaction || '' }
      this.nmDialogVisible = true
      this.$nextTick(() => this.$refs.nmForm && this.$refs.nmForm.clearValidate())
    },
    saveNm() {
      this.$refs.nmForm.validate(valid => {
        if (!valid) return
        const id = this.accountInfo.id
        this.nmSaving = true
        let url = `${this.$store.state.islhurl}valued-account/profile/${id}/network-maintenance`
        let method = 'post'
        if (this.nmEditId) {
          url += `/${this.nmEditId}`
          method = 'put'
        }
        this.$axios({ url, method, data: { maintenanceMode: this.nmForm.maintenanceMode, thirdPartyVendorName: this.nmForm.thirdPartyVendorName, thirdPartyServiceCost: this.nmForm.thirdPartyServiceCost, thirdPartyCustomerSatisfaction: this.nmForm.thirdPartyCustomerSatisfaction } }).then(res => {
          this.nmSaving = false
          const data = res.data
          if (data.code === 200) {
            this.$message.success('Saved successfully!')
            this.nmDialogVisible = false
            this.loadNmData()
          } else {
            this.$message.error(data.msg || 'Save failed!')
          }
        }).catch(() => {
          this.nmSaving = false
          this.$message.error('Save failed!')
        })
      })
    },
    deleteNm(row) {
      this.$confirm('Confirm to delete this item?', 'Confirm', { type: 'warning' }).then(() => {
        const id = this.accountInfo.id
        let url = `${this.$store.state.islhurl}valued-account/profile/${id}/network-maintenance/${row.id}`
        this.$axios.delete(url).then(res => {
          const data = res.data
          if (data.code === 200) {
            this.$message.success('Deleted successfully!')
            this.nmPage = 1
            this.loadNmData()
          } else {
            this.$message.error(data.msg || 'Delete failed!')
          }
        }).catch(() => { this.$message.error('Delete failed!') })
      }).catch(() => {})
    },
    exportNm() {
      const id = this.accountInfo.id
      if (!id) return
      this.nmExportLoading = true
      let params = {
        maintenanceMode: this.nmQuery.maintenanceMode || undefined,
        thirdPartyVendorName: this.nmQuery.thirdPartyVendorName || undefined,
        thirdPartyServiceCost: this.nmQuery.thirdPartyServiceCost || undefined,
        thirdPartyCustomerSatisfaction: this.nmQuery.thirdPartyCustomerSatisfaction || undefined,
      }
      Object.keys(params).forEach(key => { if (params[key] === undefined || params[key] === '') delete params[key] })
      this.$axios({
        url: `${this.$store.state.islhurl}valued-account/profile/${id}/network-maintenance/export`,
        method: 'get',
        params,
        responseType: 'blob'
      }).then(response => {
        this.nmExportLoading = false
        const blob = new Blob([response.data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = 'NetworkMaintenance_' + new Date().toISOString().slice(0, 10) + '.xlsx'
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.nmExportLoading = false
        this.$message.error('Export failed!')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.ap-sub-panel {
  .ap-query-row {
    margin-bottom: 8px;
    .ap-query {
      /deep/ .el-form-item { margin-bottom: 0; }
      /deep/ .el-form-item__label { font-size: 13px; color: #1F2937; }
      /deep/ .el-form-item__content .el-input__suffix {
        left: auto;
        right: 10px;
      }
    }
    .ap-btn-col {
      padding-top: 4px;
      text-align: right;
      button {
        margin-left: 5px;
      }
    }
  }
  .ap-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 12px;
    line-height: 20px;
    &.ap-tag-green { color: #52C41A; }
    &.ap-tag-blue { color: #1890FF; }
    &.ap-tag-orange { color: #FA8C16; }
    &.ap-tag-red { color: #F5222D; }
    &.ap-tag-gray { color: #8C8C8C; }
  }
  .ap-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 0 0;
    gap: 12px;
    .ap-pagination-total {
      font-size: 13px;
      color: #6B7280;
    }
  }
}
.el-button+.el-button {
  margin-left: 0;
}
</style>

<style>
.nm-dialog .el-dialog__body {
  padding: 10px 20px;
}
.nm-dialog .el-form-item {
  margin-bottom: 5px;
}
.nm-dialog .el-form--label-top .el-form-item__label {
  line-height: 28px;
  padding-bottom: 0;
  padding-top: 5px;
}
.nm-dialog .el-form-item__error {
  padding-top: 0;
}
.nm-dialog .el-form-item__content .el-input__suffix {
  left: auto;
  right: 10px;
}
.nm-dialog .el-radio {
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/accountDetailTabs/AccountProfileNetworkMaint.vue